import { render, staticRenderFns } from "./DailySales.vue?vue&type=template&id=befb3a52&scoped=true&"
import script from "./DailySales.vue?vue&type=script&lang=js&"
export * from "./DailySales.vue?vue&type=script&lang=js&"
import style0 from "./DailySales.vue?vue&type=style&index=0&id=befb3a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befb3a52",
  null
  
)

export default component.exports